import { useEffect, useRef, useState } from "react";
import {
  MdKeyboardArrowRight,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import {
  changeIntoString,
  generateDates,
  generateTimeSlots,
} from "../../utils/dates";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";
import moment from "moment";
import AppointmentService from "../../Services/AppointmentService";
import { Flex, Input, message, Select, Spin } from "antd";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import Layout from "../../Layout";
import PatientService from "../../Services/PatientService";
import UserService from "../../Services/UserService";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import { bookFreeAppointment } from "../../Redux/actions/appointmentActions";

function BookConsultant() {
  const { patientData } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.appt);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [dates, setDates] = useState([]);
  const [selectedDoctorSlots, setSelectedDoctorSlots] = useState(null);
  const [slotsLoader, setSlotsLoader] = useState(false);
  const [morningSlots, setMorningSlots] = useState([]);
  const [slotVisible, setSlotVisible] = useState(false);
  const [eveningSlots, setEveningSlots] = useState([]);
  const [lastDate, setLastDate] = useState(new Date());
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctorDetail, setDoctorDetail] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(patientData);
  const [famList, setFamList] = useState([]);
  const [consReason, setConsReason] = useState("");
  const [consultationType, setConsultationType] = useState("video");
  const pincodeFromSession = sessionStorage.getItem("availPin");
  const [checkingPincode, setCheckingPincode] = useState(
    pincodeFromSession ? pincodeFromSession : ""
  );
  const [consCode, setConsCode] = useState("");
  const [consultationReasonList, setConsultationReasonList] = useState([]);
  const [visitingAddress, setVisitingAddress] = useState("");
  const { state } = useLocation();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const [displayingSlot, setDisplayingSlot] = useState(null);

  useEffect(() => {
    fetchSlots(state?.selectedDoctor?.userId);
    setSelectedDoctor(state?.selectedDoctor);
    if (state?.selectedDoctor?.userId) {
      fetchDoctorDetail(state?.selectedDoctor?.userId);
    }
  }, [state]);

  const fetchDoctorDetail = async (doctorId) => {
    try {
      const response = await UserService.getUser({ userId: doctorId });
      if (response.data && response.data.length > 0) {
        setDoctorDetail(response.data[0]);
      }
    } catch (error) {
      console.error("Error fetching doctor details:", error);
    }
  };

  useEffect(() => {
    const datesArr = generateDates(new Date(), 30);
    setDates(datesArr);
    if (datesArr && datesArr.length !== 0) {
      handleSelectDate(datesArr[0]);
    }
  }, [selectedDoctorSlots]);

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      getFamilyList();
      setSelectedPatient(patientData);
    }
  }, [patientData]);

  const getFamilyList = async () => {
    if (patientData.parentPatientId) return;
    const payload = {
      parentPatientId: patientData?.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSlots = async (doctorId) => {
    const payload = {
      userId: doctorId,
      status: 1,
    };
    setSlotsLoader(true);

    try {
      const response = await AppointmentService.UserSavedTemplates(payload);

      if (response.data && response.data.length !== 0) {
        setSelectedDoctorSlots(response.data);

        // Generate time slots based on the selected date and filtered active slots
        const selectedDate = moment(state?.selectedDate, "MM/DD/YYYY", true);
        const activeSlots = response.data.filter((slot) => {
          const fromDate = moment(slot.fromDate, "MM/DD/YYYY", true);
          const toDate = moment(slot.toDate, "MM/DD/YYYY", true);
          return (
            slot.status === 1 &&
            selectedDate.isBetween(fromDate, toDate, "day", "[]")
          );
        });

        const timeSlots = generateTimeSlots(state?.selectedDate, activeSlots);
        setMorningSlots(timeSlots.morningSlots);
        setEveningSlots(timeSlots.eveningSlots);
      } else {
        setMorningSlots([]);
        setEveningSlots([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSlotsLoader(false);
    }
  };

  const handleSelectedTimeSlot = (selectedSlot) => {
    setSelectedSlot(selectedSlot);
  };

  const handleRoute = (route, payload) => {
    if (selectedDoctor.referralId) {
      payload.referralId = selectedDoctor.referralId;
    }
    navigate(route, { state: { appointmentPayload: payload } });
  };

  const handleContinueBooking = () => {
    const slotbookingPayload = {
      selectedDate,
      selectedSlot,
      selectedDoctor: displayingSlot,
      selectedPatient,
      consReason,
      consultationType,
      complaintCode: consCode ? consCode : "",
    };

    const fee =
      consultationType === "video"
        ? displayingSlot?.videoFee
        : consultationType === "inPerson"
        ? displayingSlot?.inpersonFee
        : displayingSlot?.homeVisitFee;

    const isFeeInvalid = fee <= 0;

    if (isFeeInvalid) {
      handleFreeBooking(slotbookingPayload);
    } else {
      handleRoute(APP_ROUTES.CHECKOUT, slotbookingPayload);
    }
  };

  const handleScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
    if (scrollLeft + clientWidth >= scrollWidth - 5) {
      loadMoreDates();
    }
  };

  const handleFreeBooking = (slotbookingPayload) => {
    dispatch(bookFreeAppointment(slotbookingPayload))
      .then((result) => {
        if (!result) {
          message.error("Registration Failed, Retry");
          return;
        }

        if (result?.data?.code === "SUCCESS") {
          message.success("Appointment Booked Successfully");
        }
      })
      .catch((err) => {
        console.log("Booking Failed:", err);
        message.error("Booking Failed");
      });
  };

  const loadMoreDates = () => {
    const newLastDate = new Date(lastDate);
    newLastDate.setDate(lastDate.getDate() + 30);

    const newDates = generateDates(newLastDate, 30);
    setDates((prevDates) => [...prevDates, ...newDates]);
    setLastDate(newLastDate);
  };

  const handleSelectDate = (dateObj) => {
    try {
      const selectedDate = moment(dateObj.fullDate, "MM/DD/YYYY", true);
      if (!selectedDate.isValid()) {
        console.error("Invalid date selected:", dateObj.fullDate);
        return resetSlotState();
      }
      setSelectedDate(dateObj.fullDate);
      setSelectedSlot("");
      if (!selectedDoctorSlots || selectedDoctorSlots.length === 0) {
        return resetSlotState();
      }
      const activeSlots = selectedDoctorSlots.filter((slot) => {
        const fromDate = moment(slot.fromDate, "MM/DD/YYYY", true);
        const toDate = moment(slot.toDate, "MM/DD/YYYY", true);
        return (
          slot.status === 1 &&
          selectedDate.isBetween(fromDate, toDate, "day", "[]")
        );
      });
      if (activeSlots.length === 0) {
        return resetSlotState();
      }
      const slot = activeSlots[0];
      const consultationType =
        slot.video === "Y"
          ? "video"
          : slot.inPerson === "Y"
          ? "inPerson"
          : slot.homeVisit === "Y"
          ? "homeVisit"
          : "";

      setConsultationType(consultationType);
      setDisplayingSlot(slot);
      const timeSlots = generateTimeSlots(dateObj.fullDate, activeSlots);
      if (!timeSlots) {
        console.warn("No valid time slots generated.");
        return resetSlotState();
      }
      setMorningSlots(timeSlots.morningSlots);
      setEveningSlots(timeSlots.eveningSlots);
      setSlotVisible(true);
    } catch (error) {
      console.error("Error in handleSelectDate:", error);
      resetSlotState();
    }
  };

  const resetSlotState = () => {
    setSlotVisible(false);
    setMorningSlots([]);
    setEveningSlots([]);
    setDisplayingSlot(null);
  };

  const scrollLeft = () => {
    containerRef.current.scrollBy({ left: -100, behavior: "smooth" });
  };

  const scrollRight = () => {
    containerRef.current.scrollBy({ left: 100, behavior: "smooth" });
  };

  const handlePatientChange = (value) => {
    if (value === patientData?.patientId) {
      setSelectedPatient(patientData);
    } else {
      const selectedPatObj = famList.find((pat) => pat.patientId === value);
      setSelectedPatient(selectedPatObj);
    }
  };
  const handleConsSelectChange = (reason) => {
    setConsReason(reason?.chiefComplaint ? reason?.chiefComplaint : "");
    setConsCode(reason?.complaintCode ? reason?.complaintCode : "");
    setConsultationReasonList([]);
  };

  const handleConsReason = (e) => {
    setConsReason(e.target.value);
    let value = e.target.value;
    if (value && value.length >= 3) {
      const payload = {
        chiefComplaint: value,
      };
      fetchConsReasons(payload);
    }
  };

  const fetchConsReasons = async (filterPayload) => {
    const payload = {
      chiefComplaint: "",
      status: 1,
    };
    let finalPayload;
    if (filterPayload) {
      finalPayload = {
        ...payload,
        ...filterPayload,
      };
    }
    try {
      const response = await PatientService.AllConsReasons(finalPayload);
      setConsultationReasonList(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleApptValidation = async () => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    } else if (!consReason) {
      message.error("Please fill in the consultation reason.");
      return;
    }

    if (!selectedDate || !selectedSlot) {
      message.error("Please select Date and slot!");
      return;
    }

    if (
      (consultationType == "inPerson" || consultationType == "homeVisit") &&
      checkingPincode == ""
    ) {
      message.error("Enter Valid Pincode to check Service availability");
      return;
    } else {
      let payload = {
        userId: selectedDoctor.userId,
        clinicPincode: checkingPincode,
        displayInWebsite: "Y",
        status: 1,
      };
      const response = await UserService.getDoctors(payload);
      if (response.data.length == 0) {
        message.error("Consultation is not available in this entered pincode");
        return;
      }
    }
    if (consultationType == "homeVisit" && visitingAddress == "") {
      message.error("Enter Visiting Address");
      return;
    }

    handleContinueBooking();
  };

  const handleChange = (event) => {
    setConsultationType(event.target.value);
  };

  const convertTo12HourFormat = (time) => {
    return dayjs(time, "HH:mm").format("h:mm A");
  };

  return (
    <>
      <Layout>
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        {slotsLoader ? (
          <div className="flex items-center justify-center mt-[10%]">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : (
          <div className="w-full max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-4">
            <div className="bg-white shadow-md rounded-lg p-6">
              <div className="flex sm:flex-col">
                <div>
                  <div className="flex sm:flex-col justify-between mx-4">
                    <div>
                      {selectedDoctor?.imageName ? (
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            selectedDoctor?.imageName
                          }
                          alt="DoctorPic"
                          className="w-32 h-28 mx-auto rounded-sm"
                        />
                      ) : (
                        <img
                          src={doctorIcon}
                          alt="DoctorPic"
                          className="w-40 sm:w-20 h-28 mx-auto rounded-sm"
                        />
                      )}
                    </div>
                    <div>
                      <p className="text-[#189FAA] text-2xl sm:text-xl font-bold">
                        {`${selectedDoctor?.salutation}${selectedDoctor?.firstName} ${selectedDoctor?.lastName}`}
                      </p>
                      <p className="mt-1 text-base font-semibold text-gray-700">
                        {selectedDoctor?.speciality}
                      </p>
                      <p className="text-gray-700 mt-2">
                        <span className="font-semibold text-[#189FAA]">
                          Qualification:
                        </span>{" "}
                        {selectedDoctor?.qualification}
                      </p>
                      {/* <p className="text-gray-700 mt-2">
                      <span className="font-semibold text-[#002F72]">
                        Experience:
                      </span>{" "}
                      10 Years
                    </p> */}
                      <p className="text-gray-700 mt-2">
                        <span className="font-semibold text-[#189FAA]">
                          Location:
                        </span>{" "}
                        {selectedDoctor?.city}
                      </p>
                      {/* <p className="text-gray-700 mt-2">
                      <span className="font-semibold text-[#002F72]">
                        Language:
                      </span>{" "}
                      Tamil, English, Hindi, Telugu
                    </p> */}
                    </div>
                  </div>
                  <div className="mt-6">
                    <div className="mt-4">
                      <div className="mt-4">
                        <h2 className="text-xl sm:text-sm font-semibold text-[#189FAA]">
                          About the Doctor
                        </h2>
                        <p className="text-gray-700 sm:text-sm mt-2">
                          {doctorDetail?.aboutme ? (
                            doctorDetail.aboutme
                          ) : (
                            <>
                              {`${selectedDoctor?.salutation}.${selectedDoctor?.firstName} ${selectedDoctor?.lastName}`}{" "}
                              is {selectedDoctor?.qualification} and fellowship
                              in Advanced {selectedDoctor?.speciality}. He is
                              renowned {selectedDoctor?.speciality} of{" "}
                              {selectedDoctor?.city}. Currently,{" "}
                              {`${selectedDoctor?.salutation}${selectedDoctor?.firstName}`}{" "}
                              is associated with Doxzon Care.
                            </>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-[40%] sm:w-full mx-auto p-4 bg-white border rounded-lg shadow-md">
                  <div className="grid grid-cols-2 sm:grid-cols-1 ">
                    {patientData?.patientId && (
                      <div className="p-3">
                        {!patientData?.parentPatientId && (
                          <div className="w-full">
                            {/* <MdFamilyRestroom className="text-iconBlue" /> */}
                            <label className="text-base font-semibold text-textGray">
                              Select Patient
                            </label>
                            <Select
                              className="w-52 sm:w-full h-10"
                              value={selectedPatient?.patientId}
                              onChange={handlePatientChange}
                            >
                              <Select.Option value={patientData?.patientId}>
                                {patientData?.firstName}
                              </Select.Option>
                              {famList.length !== 0 &&
                                famList.map((fam) => (
                                  <Select.Option value={fam.patientId}>
                                    {fam.firstName}
                                  </Select.Option>
                                ))}
                            </Select>
                          </div>
                        )}
                      </div>
                    )}
                    <div className="w-full text-primaryColor p-3 relative">
                      <label className="text-base font-semibold text-textGray">
                        Reason <span className="text-red-500">*</span>
                      </label>
                      <Input
                        value={consReason}
                        onChange={handleConsReason}
                        className="w-52 sm:w-full h-10 rounded-lg outline-none"
                        placeholder="Enter Consultation Reason"
                        maxLength={25}
                      />
                      {consultationReasonList.length > 0 && (
                        <ul
                          onMouseLeave={() => setConsultationReasonList([])}
                          className="absolute top-20 left-1/2 -translate-x-1/2 w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-20"
                        >
                          {consultationReasonList.map((reason, index) => (
                            <li
                              onClick={() => handleConsSelectChange(reason)}
                              key={index}
                              className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                            >
                              {reason.chiefComplaint}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-cols   border-b pb-2 mb-1">
                    {!slotsLoader && displayingSlot && (
                      <div className="grid grid-cols-2 sm:grid-cols-1 pb-2 mt-3 ml-4">
                        {/* Video */}
                        {displayingSlot.video === "Y" && (
                          <label className="flex items-center space-x-2">
                            <input
                              type="radio"
                              name="consultationType"
                              value="video"
                              className="accent-[#189FAA]"
                              checked={consultationType === "video"}
                              onChange={handleChange}
                            />
                            <span className="text-sm font-bold text-[#189FAA]">
                              Video Consultation
                            </span>
                          </label>
                        )}

                        {/* In-Person */}
                        {displayingSlot.inPerson === "Y" && (
                          <label className="flex items-center space-x-2 ">
                            <input
                              type="radio"
                              name="consultationType"
                              value="inPerson"
                              className="accent-[#189FAA]"
                              checked={consultationType === "inPerson"}
                              onChange={handleChange}
                            />
                            <span className="text-sm font-bold text-[#189FAA]">
                              In-Person Consultation
                            </span>
                          </label>
                        )}

                        {/* Home Visit */}
                        {displayingSlot.homeVisit === "Y" && (
                          <label className="flex items-center space-x-2">
                            <input
                              type="radio"
                              name="consultationType"
                              value="homeVisit"
                              className="accent-[#189FAA]"
                              checked={consultationType === "homeVisit"}
                              onChange={handleChange}
                            />
                            <span className="text-sm font-bold text-[#189FAA]">
                              Home Visit
                            </span>
                          </label>
                        )}

                        {/* No Services */}
                        {displayingSlot.video === "N" &&
                          displayingSlot.inPerson === "N" &&
                          displayingSlot.homeVisit === "N" && (
                            <span className="text-sm text-gray-500">
                              No Consultation Services
                            </span>
                          )}
                      </div>
                    )}
                  </div>
                  {(consultationType === "inPerson" ||
                    consultationType === "homeVisit") && (
                    <div className="mt-3">
                      <div className="w-full flex flex-col text-primaryColor p-3">
                        <label className="text-base font-semibold text-textGray">
                          Enter Pincode <span className="text-red-500">*</span>
                        </label>
                        <input
                          value={checkingPincode}
                          onChange={(e) => setCheckingPincode(e.target.value)}
                          type="text"
                          placeholder="Enter an Indian pincode"
                          className="flex-1 border border-gray-300 rounded p-2 text-sm outline-none"
                        />
                      </div>
                    </div>
                  )}

                  {consultationType === "homeVisit" && (
                    <div className="mt-1">
                      <div className="w-full flex flex-col text-primaryColor p-3">
                        <label className="text-base font-semibold text-textGray">
                          Visiting Address{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <textarea
                          value={visitingAddress}
                          onChange={(e) => setVisitingAddress(e.target.value)}
                          type="text"
                          placeholder="Enter Address"
                          className="flex-1 border border-gray-300 rounded p-2 text-sm outline-none"
                        />
                      </div>
                    </div>
                  )}
                  <div>
                    <div>
                      <div className="flex justify-between items-center border-b pb-2 mb-4 mt-2">
                        <div className="text-lg sm:text-sm font-medium">
                          {consultationType === "video"
                            ? "Video Consultation"
                            : consultationType === "inPerson"
                            ? "In-Person Consultation"
                            : consultationType === "homeVisit"
                            ? "Home visit Consultation"
                            : ""}
                        </div>
                        <div className="text-lg sm:text-sm rounded-md p-1 bg-primaryColor text-white font-semibold">
                          {consultationType === "video"
                            ? displayingSlot?.videoFee
                            : consultationType === "inPerson"
                            ? displayingSlot.inpersonFee
                            : consultationType === "homeVisit"
                            ? displayingSlot.homeVisitFee
                            : ""}
                        </div>
                      </div>
                    </div>

                    {/* Date Selection */}
                    <div className="w-full flex justify-evenly items-center gap-1 mb-4">
                      {/* Left Arrow */}
                      <div className="w-[10%]">
                        <MdOutlineKeyboardArrowLeft
                          onClick={scrollLeft}
                          className="w-10 h-10 text-[#189FAA] cursor-pointer"
                        />
                      </div>
                      {/* Date Container */}
                      <div
                        ref={containerRef}
                        onScroll={handleScroll}
                        className="flex items-center gap-3 overflow-x-auto scrollWidth"
                        style={{ scrollBehavior: "smooth" }}
                      >
                        {dates.map((dateObj, index) => (
                          <button
                            key={index}
                            onClick={() => handleSelectDate(dateObj)}
                            className={`flex flex-col items-center px-3 py-2 border rounded-md ${
                              selectedDate === dateObj.fullDate
                                ? "bg-blue-100 border-[#189FAA]"
                                : "bg-white"
                            }`}
                          >
                            <span>{dateObj.day}</span>
                            <span>{dateObj.date}</span>
                            <span>{dateObj.month}</span>
                          </button>
                        ))}
                      </div>

                      {/* Right Arrow */}
                      <div className="w-[10%]">
                        <MdKeyboardArrowRight
                          onClick={scrollRight}
                          className="w-10 h-10 text-[#189FAA] cursor-pointer"
                        />
                      </div>
                    </div>
                    {selectedDate && (
                      <div className="p-1 font-semibold text-lg sm:text-sm">
                        {changeIntoString(selectedDate)}
                      </div>
                    )}
                    {/* Slot Selection */}
                    {slotsLoader ? (
                      <div className="flex items-center justify-center h-[200px]">
                        <Flex align="center" gap="middle">
                          <Spin size="large" tip="Loading" />
                        </Flex>
                      </div>
                    ) : (
                      <div className="w-full flex flex-col items-center border-t pt-4">
                        <div className="flex flex-col items-center mb-4">
                          <p className="text-[#189FAA] font-semibold mb-2">
                            MORNING SLOTS
                          </p>
                          {slotVisible && morningSlots.length !== 0 ? (
                            <div className="flex flex-wrap justify-between gap-2 w-full">
                              {morningSlots.map((slot, index) => (
                                <button
                                  key={index}
                                  onClick={() => handleSelectedTimeSlot(slot)}
                                  className={`px-4 py-2 border rounded-md ${
                                    selectedSlot === slot
                                      ? "bg-blue-100 border-[#189FAA]"
                                      : "bg-white"
                                  }`}
                                >
                                  {convertTo12HourFormat(slot)}
                                </button>
                              ))}
                            </div>
                          ) : (
                            <div className="w-full h-[inherit] min-h-14 flex items-center justify-center">
                              <p className="font-semibold">
                                No slots available
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col items-center mb-4">
                          <p className="text-[#189FAA] font-semibold mb-2">
                            AFTERNOON SLOTS
                          </p>
                          {slotVisible && eveningSlots.length !== 0 ? (
                            <div className="flex flex-wrap justify-between gap-2 w-full">
                              {eveningSlots.map((slot, index) => (
                                <button
                                  key={index}
                                  onClick={() => handleSelectedTimeSlot(slot)}
                                  className={`px-4 py-2 border rounded-md ${
                                    selectedSlot === slot
                                      ? "bg-blue-100 border-[#189FAA]"
                                      : "bg-white"
                                  }`}
                                >
                                  {convertTo12HourFormat(slot)}
                                </button>
                              ))}
                            </div>
                          ) : (
                            <div className="w-full h-[inherit] min-h-14 flex items-center justify-center">
                              <p className="font-semibold">
                                No slots available
                              </p>
                            </div>
                          )}
                        </div>

                        {/* Continue Booking Button */}
                        <button
                          onClick={handleApptValidation}
                          className="mt-4 w-full py-2 bg-[#189FAA] sm:text-xs text-white  font-semibold rounded-lg"
                        >
                          Continue Booking
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Layout>
    </>
  );
}

export default BookConsultant;
